<div *transloco="let t">
	<mat-dialog-content>
		@switch (type) {
			@case ('img') {
				<img class="img-responsive" alt="" [src]="imageSrc" [style.height]="height()" [style.width]="width()" />
			}
			@case ('qr') {
				<div #qrCodeContainer>
					<ara-qr-generator [width]="300" [permission]="permission"></ara-qr-generator>
				</div>
			}
		}
	</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
		@if (type === 'qr') {
			<button (click)="copyQrCodeImage()" class="m-2" color="primary" mat-raised-button>
				<mat-icon>content_copy</mat-icon>
				{{ t('permissions.copyQrImage') }}
			</button>
		}
		<button (click)="dialogRef.close()" class="m-2" mat-raised-button>{{ t('commonActions.close') }}</button>
	</mat-dialog-actions>
</div>
